export default __webpack_public_path__ + "static/media/lightning.d9816d16.svg";